//定义下钻图层配置
let layer_Drilldown=[
  {
    "levelName":"全国",
    "level":0,
    "layerId":"国界",
    "sourceId":"dt_gj",
    "sourceLayer":"dt_gj",
    "ptLayerId":"中国",
    "sourceId_pt":"dt_gj_pt",
    "sourceLayer_pt":"dt_gj_pt",
    "minzoom":0,
    "maxzoom":3.5,
    "layer_ht":"",
    "layer_fill":"",
    "layer_bk":""
  },
  {
    "levelName":"省",
    "level":1,
    "layerId":"省域",
    "sourceId":"dt_sy",
    "sourceLayer":"dt_sy",
    "ptLayerId":"省点",
    "sourceId_pt":"dt_sy_pt",
    "sourceLayer_pt":"dt_sy_pt",
    "minzoom":3,
    "maxzoom":6,/*把省写低一个级别，正常是7，为了省域的下钻图层和地市域的下钻图层不重叠*/
    "layer_ht":"dt_sy_ht",
    "layer_fill":"dt_sy_fill",
    "layer_bk":"dt_sy_bk"
  },
  {
    "levelName":"地市",
    "level":2,
    "layerId":"地市域",
    "sourceId":"dt_dsy",
    "sourceLayer":"dt_dsy",
    "ptLayerId":"地市点",
    "sourceId_pt":"dt_dsy_pt",
    "sourceLayer_pt":"dt_dsy_pt",
    "minzoom":6,
    "maxzoom":8,
    "layer_ht":"dt_dsy_ht",
    "layer_fill":"dt_dsy_fill",
    "layer_bk":"dt_dsy_bk"
  },
  {
    "levelName":"县",
    "level":3,
    "layerId":"县域",
    "sourceId":"dt_xy",
    "sourceLayer":"dt_xy",
    "ptLayerId":"县点",
    "sourceId_pt":"dt_xy_pt",
    "sourceLayer_pt":"dt_xy_pt",
    "minzoom":8,
    "maxzoom":10,
    "layer_ht":"dt_xy_ht",
    "layer_fill":"dt_xy_fill",
    "layer_bk":"dt_xy_bk"
  },
  {
    "levelName":"乡镇",
    "level":4,
    "layerId":"乡镇域",
    "sourceId":"dt_xzy",
    "sourceLayer":"dt_xzy",
    "ptLayerId":"乡镇点",
    "sourceId_pt":"dt_xzy_pt",
    "sourceLayer_pt":"dt_xzy_pt",
    "minzoom":10,
    "maxzoom":12,
    "layer_ht":"dt_xzy_ht",
    "layer_fill":"dt_xzy_fill",
    "layer_bk":"dt_xzy_bk"
  },
  {
    "levelName":"村",
    "level":5,
    "layerId":"村域",
    "sourceId":"dt_cy",
    "sourceLayer":"dt_cy",
    "ptLayerId":"村点",
    "sourceId_pt":"dt_cy_pt",
    "sourceLayer_pt":"dt_cy_pt",
    "minzoom":12,
    "maxzoom":18,
    "layer_ht":"dt_cy_ht",
    "layer_fill":"dt_cy_fill",
    "layer_bk":"dt_cy_bk"
  }
]

//查询图层及优先级别配置
let query_layer_setting =
  [
    {
      "source":"dt_cknh",
      "layerid":"农户",
      "priority":10,
      "qMode":1,  //1表示查图层属性，2表示挂接其他查询信息卡
    },
    {
      "source": "dt_zzdk",
      "layerid": "种植地块",
      "priority": 5,
      "qMode":2,  //1表示查图层属性，2表示挂接其他查询信息卡
    },
    {
      "source": "dt_zzdk",
      "layerid": "isearch_zzdk",
      "priority": 5,
      "qMode":2,  //1表示查图层属性，2表示挂接其他查询信息卡
    },
    {
      "source":"dt_zzjg",
      "layerid":"种植结构",
      "priority":6,
      "qMode":1,  //1表示查图层属性，2表示挂接其他查询信息卡
    },
    {
      "source":"dt_zzybdkb",
      "layerid":"承保图层",
      "priority":7,
      "qMode":1,  //1表示查图层属性，2表示挂接其他查询信息卡
    },
  ]

export default {
  layer_Drilldown:layer_Drilldown,
  query_layer_setting:query_layer_setting,
}




// WEBPACK FOOTER //
// ./src/config/layer_identify.js